import React, { useState, useEffect, useRef } from "react";
import { DocProfileData } from "../../services/types";
import { DataForCheckdin } from "../../lib/utils/types";
import MainHeader from "./MainHeader";
import DocDetailsHeader from "./DocDetailsHeader";
import NotificationBell from "./notifications/NotificationBell";
import Notifications from "./notifications/Notifications";
import { getUnreadNotificationsCount } from "../../lib/apis/notifications";
import { useUserData } from "../../lib/contexts/UserContext";
import { useFeatureFlags } from "../../lib/contexts/FeatureFlagContext";

const Header = ({
  header,
  value,
  docData,
  data,
  isLoading,
  breadcrumb,
  backLink,
}: {
  header?: boolean;
  value?: string;
  docData?: DocProfileData;
  data?: DataForCheckdin;
  isLoading?: boolean;
  breadcrumb?: string;
  backLink?: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [newNotifications, setNewNotifications] = useState(0);
  const { userData } = useUserData();
  const { notification } = useFeatureFlags();
  
  // --- CHANGE 1: Removed all the polling and audio logic from here ---
  // Since MainHeader handles it when 'header' is true, 
  // we only need simple fetching here if we are NOT returning MainHeader.

  const fetchUnreadCount = async () => {
    if (!isOpen && userData?.user_id) {
      const count = await getUnreadNotificationsCount(userData?.user_id, false);
      setNewNotifications(count);
    }
  };

  useEffect(() => {
    // Only poll here if we are NOT rendering MainHeader (to avoid double polling)
    if (userData?.role !== "Doctor" && !header) {
      fetchUnreadCount();
      const interval = setInterval(fetchUnreadCount, 60000); // Increased to 60s to be safe
      return () => clearInterval(interval);
    }
  }, [isOpen, userData?.user_id, header]); // Added 'header' to dependencies

  const handleNotificationsFetched = () => {
     // Optional: Refresh count after opening
     fetchUnreadCount();
  };

  if (header) {
    return <MainHeader value={value} breadcrumb={breadcrumb} backLink={backLink} />;
  }

  return (
    <header>
      {/* Audio ref removed from here, let MainHeader handle it or NotificationContext */}
      <DocDetailsHeader docData={docData} data={data} />
      {notification && !docData && userData?.role!=="Doctor" && (
        <NotificationBell
          onClick={() => setIsOpen(true)}
          newNotifications={newNotifications}
          hasUnread={newNotifications > 0}
        />
      )}
      {notification && (
        <Notifications
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onFetched={handleNotificationsFetched}
          userId={userData?.user_id}
          onStateChange={fetchUnreadCount}
        />
      )}
    </header>
  );
};

export default Header;